<main class="mat-body">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress-assignment [percent]="66"></thr-contract-progress-assignment>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'rate.title'|translate"></h1>
                    </div>
                    <div class="col-auto">
                        {{ 'operative.contract-code'|translate }}
                        <strong class="text-blue">{{ contract?.bankCode }} </strong>
                    </div>
                </div>
                <hr class="mt-1 mb-3" />
            </div>
        </div>

        <form #formRate="ngForm" novalidate autocomplete="off" (submit)="onSubmit()" *ngIf="fee">
            <div class="row">
                <div class="col-12 order-1 col-md-6 order-md-0">
                    <thr-chart-doughnut [data]="chartData" *ngIf="chartData && chartData.length > 0; else chartPlaceholder"></thr-chart-doughnut>
                    <ng-template #chartPlaceholder>
                        <p class="text-muted text-center mt-5">
                            <small><i>{{ 'rate.chart.select-your-model-to-display-chart'|translate }}</i></small>
                        </p>
                    </ng-template>
                </div>
                <div class="col-12 order-0 col-md-6 order-md-1">
                    <thr-rate-form [data]="fee" [feedAmount]="feedAmount" [currentModelName]="currentModelName" [currentModelId]="currentModelId" [validModels]="validModels" [showInvestment]="false" (changeDistributions)="onChangeDistributions($event)" (download)="onDownload($event)"
                        (evaluateFee)="onEvaluateFee($event)" (currentSelected)="onCurrentSelected($event)"></thr-rate-form>
                </div>
            </div>

            <div class="row justify-content-end mt-5 mb-4">
                <div class="col-12 col-sm-6 col-md-4">
                    <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!formRate.valid || !currentSelected">
                        {{ 'general.continue'|translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</main>
